import React, { useEffect, useState } from "react";
import { Booking } from "../../events/Interface";
import { GET } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import { BookingCard, BookingCardSkeleton } from "./BookingCard";
import { Link, useNavigate } from "react-router-dom";

export const UpcomingBooking = () => {
    const { getUpcomingEventDashboardApi } = API_ROUTES;
    const [bookings, setBookings] = useState<Booking[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { refreshToken, business_id } = useAppSelector((store) => store.user);
    const { currentBusiness } = useAppSelector((store) => store.business);
    const navigate = useNavigate();
    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const res = await GET(
                    `${getUpcomingEventDashboardApi}?business_id=${currentBusiness ? currentBusiness : business_id}`,
                    refreshToken
                );
                setBookings(res.data);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [currentBusiness]);

    return (
        <div className="p-3 h-full flex flex-col min-h-0">
            {/* Header */}
            <div className="flex justify-between items-start mb-3 shrink-0">
                <p className="text-xl font-semibold">
                    Bookings{" "}
                    {bookings.length > 0 && (
                        <span className="bg-primary-red py-1 px-2 rounded-lg text-white text-base">
                            {bookings.length}
                        </span>
                    )}
                </p>
                <Link
                    to="/events?tab=Bookings"
                    className="bg-black text-white rounded-full py-2 px-6 text-sm"
                >
                    View All
                </Link>
            </div>
            <div className="flex flex-col gap-3 flex-1 min-h-0 overflow-y-auto ">
                {isLoading ? (
                    <>
                        <BookingCardSkeleton />
                        <BookingCardSkeleton />
                    </>
                ) : bookings.length > 0 ? (
                    bookings.map((b: Booking) => {
                        return (
                            <div
                                className="mr-3"
                                onClick={() => {
                                    navigate("/events?tab=Bookings", { state: { url: b.id } });
                                }}
                                key={b.id}
                            >
                                <BookingCard booking={b} />
                            </div>
                        );
                    })
                ) : (
                    <div className="flex-1 flex items-center justify-center">
                        <p className="text-center text-gray-500">No Booking</p>
                    </div>
                )}
            </div>
        </div>
    );
};
